import { List, Typography, Card } from 'antd';
import { Link } from 'react-router-dom';
import gummadi from './Images/gummadi.jpeg';
import redmiles from './Images/redmiles.jpeg';
import roesner from './Images/roesner.jpeg';
import zannettou from './Images/zannettou.jpg';
import ingmar from './Images/ingmar.jpg';
import './App.css';

const { Text, Title } = Typography;

const researcherData = [
    {
        image: gummadi,
        name: "Krishna P. Gummadi",
        about: "Krishna Gummadi is a scientific director and head of the Networked Systems research group at the Max Planck Institute for Software Systems (MPI-SWS) in Germany.\
 He also holds a professorship at the University of Saarland.\
 He received his Ph.D. (2005) and B.Tech. (2000) degrees in Computer Science and Engineering from the University of Washington and the Indian Institute of Technology,\
 Madras, respectively.\n\nKrishna's research interests are in the measurement, analysis, design, and evaluation of complex Internet-scale systems.\
 His current projects focus on understanding and building social computing systems. \
 Specifically, they tackle the challenges associated with (1) assessing the credibility of information shared by anonymous online crowds,\
 (2) understanding and controlling privacy risks for users sharing data on online forums,\
 (3) understanding, predicting and influencing human behaviors on social media sites (e.g., viral information diffusion),\
 and (4) enhancing fairness and transparency of machine (data-driven) decision making in social computing systems.\
 \n\nKrishna's work on fair machine learning, online social networks and media, Internet access networks,\
 and peer-to-peer systems has been widely cited and his papers have received numerous awards, including Test of Time Awards at ACM SIGCOMM and AAAI ICWSM,\
 Casper Bowden Privacy Enhancing Technologies (PET) and CNIL-INRIA Privacy Runners-Up Awards, IW3C2 WWW Best Paper Honorable Mention,\
 and Best Papers at NIPS ML & Law Symposium, ACM COSN, ACM/Usenix SOUPS, AAAI ICWSM, Usenix OSDI, ACM SIGCOMM IMC, ACM SIGCOMM CCR, and SPIE MMCN.\
 He has also co-chaired AAAI's ICWSM 2016, IW3C2 WWW 2015, ACM COSN 2014, and ACM IMC 2013 conferences.\
 He received an ERC Advanced Grant in 2017 to investigate \"Foundations for Fair Social Computing\".",
        website: "https://people.mpi-sws.org/~gummadi/"
    },
    {
        image: ingmar,
        name: "Ingmar Weber",
        about: "Ingmar is an Alexander von Humboldt Professor in AI at Saarland University where holds the Chair for Societal Computing.\
This interdisciplinary area comprises (i) computing of society, i.e. the measurement of different social phenomena, in particular using non-traditional data sources, and (ii) computing for society, i.e. working with partners on implementing solutions to help address societal challenges.",
        website: "https://ingmarweber.de/"
    },
    {
        image: zannettou,
        name: "Savvas Zannettou",
        about: "Savvas Zannettou is an Assistant Professor at TU Delft and an associated researcher at the Max Planck Institute for Informatics.\
 He obtained his PhD in Computer Science from Cyprus University of Technology and during his PhD studies he did internships at Telefonica Research\
 and was a visiting scholar at University of Alabama at Birmingham.\
 \n\nHis research focuses on applying machine learning and data-driven quantitative analysis to understand\
 emerging phenomena on the Web such as the spread of false information and hateful rhetorics.\
 More recently, he is interested on understanding and improving content moderation online, as well as\
 assessing how recommendation algorithms are affecting people's watching habits online on platforms like YouTube and TikTok.\
 \n\nHis research has been published at top-tier conferences such as AAAI ICWSM, WWW, and ACM IMC.\
 He and his co-authors have received several awards including a distinguished paper award at ACM IMC 2018, best paper honorable mention awards at ICWSM 2020/CSCW 2021, and a best paper award at CyberSafety Workshop in 2019.",
        website: "https://zsavvas.github.io/"
    }
]

function ResearcherCard({ image, name, about, website }) {
    return (
        <Card className="TopMargin">
            <Card.Meta
                avatar={<img className="ResearcherPortrait" src={image} />}
                title={name}
                description={
                    <div>
                        <Text>{about}</Text>
                        <br /><br />
                        <Text strong>{"Website: "}</Text>
                        <a href={website} target="_blank">
                            {website}
                        </a>
                    </div>}
            />
        </Card>
    );
};

export const AboutResearchers = () => {
    return (
        <div>
            <Title level={2}>Our Research Team</Title>
        <List className="Text">
            {researcherData.map((item) => (
                <ResearcherCard {...item} />
            ))}
        </List>
        </div>
    );
}

export default AboutResearchers;